import { FiscalYear } from "api/fiscal_years";
import { FixedAsset } from "./FixedAsset";
import { Inventory } from "./Inventory";
import { Dayjs } from "dayjs";

export interface CommercialDocument {
  id: number;
  contact_id: number;
  reference: string;
  status: string;
  total_amount: string;
  issue_date: string;
  due_date: string;
  supply_date: string;
  doc_kind?: string;
  inventory_id?: number;
  description?: string;
  untracked_products_count?: number;
  addition_transactions_count?: number;
  type?: string;
}

export interface AllCommercialDocuments {
  documents: CommercialDocument[];
}

export interface LineItem {
  id: number;
  quantity: number;
  unit_price: number;
  product_id?: number;
  product_description?: string;
  is_inclusive: boolean;
  discount_percentage: number;
  discount_type: string;
  total_before_vat?: number;
  tax_id: number;
  unit_type: number;
  vat_value?: number;
  amount?: number;
  product?: FixedAsset;
}

export interface Bill extends CommercialDocument {
  line_items?: LineItem[];
  bill_items?: LineItem[];
  bill_items_attributes?: LineItem[];
  inventory?: Inventory;
}

export interface CommercialDocumentFilters {
  fiscal_year_id?: number | string;
  fiscal_year_name?: string;
  fiscal_period_id?: number | string;
  fiscal_period_name?: string;
  from_date?: string;
  to_date?: string;
}

export interface ApiFilters extends CommercialDocumentFilters {
  document_type: string;
  limit?: string;
  page?: string;
}

export interface EnhancedFilterProps {
  filters: CommercialDocumentFilters;
  onFiltersChange: (filters: Partial<CommercialDocumentFilters>) => void;
  onReset: () => void;
}

export interface FilterProps {
  setFilterData: (values: FilterDate) => void;
  reset: () => void;
}

export interface CDProps {
  type: string;
  filters: CommercialDocumentFilters;
}

export interface FilterDate {
  from_date: string | undefined;
  to_date: string | undefined;
}

export interface FiscalYearDropdownProps {
  value?: number;
  onChange?: (id?: number, name?: string) => void;
  placeholder?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  fiscalYears: FiscalYear[];
}

export interface MonthDropdownProps {
  value?: number;
  onChange?: (id?: number, name?: string) => void;
  placeholder?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  fiscalYearId?: number;
}

export interface UnifiedFilterProps {
  showFiscalFilters?: boolean;
  filters?: CommercialDocumentFilters;
  setFilterData?: FilterProps["setFilterData"];
  reset?: FilterProps["reset"];
  onFiltersChange?: EnhancedFilterProps["onFiltersChange"];
  onReset?: EnhancedFilterProps["onReset"];
}

export interface FormValues {
  dateRange?: [Dayjs, Dayjs];
  fiscal_year_id?: number | string;
  fiscal_period_id?: number | string;
  fiscal_year_name?: string;
  fiscal_period_name?: string;
}

export enum CommercialDocumentName {
  INVOICE = "invoice",
  CREDIT_NOTE = "credit_note",
  DEBIT_NOTE = "debit_note",
  SALES_DEBIT_NOTE = "sales_debit_note",
  QUOTATION = "quotation",
  PURCHASE_ORDER = "purchase_order",
}
